<template>
    <div>
      <div class="category-top-bar" ref="optionsTopBar">
        <div class="top-bar">
        <p>
          <a class="btn btn-orange btn-icon back" @click="goBack">
            <i class="ti-arrow-left"></i>
            {{ $t('general.back') }}
          </a>
        </p>
        <p class="d-inline-flex">
            <button type="submit" class="btn btn-icon btn-success mar-rt-10 save" style="margin-bottom: 0;" @click="saveBonConsum()" :title="$t('general.save')">
              <img src="/static/img/icons/save.png">
              {{$t('general.save')}}
            </button>
        </p>
        </div>
      </div>
      <div class="card">
        <div class="card-content">
          <div class="modal-header">
            <p>{{ $t('gestiune.stoc.action.bonConsum') }}</p>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-2">
                <div class="form-group">
                  <label>{{ $t('gestiune.locatie') }}</label>
                  <select class="form-control" v-model="selectedLocationId" :disabled="isEdit">
                    <option value="" disabled>Selectează locația</option>
                    <optgroup
                      v-for="group in groupedLocations"
                      :key="group.vat"
                      :label="`VAT: ${group.vat}`"
                    >
                      <option
                        v-for="loc in group.locations"
                        :key="loc.true_id"
                        :value="loc.true_id"
                      >
                        {{ loc.name }}
                      </option>
                    </optgroup>
                  </select>
                </div>
              </div>

              <div class="col-md-2">
                <div class="form-group">
                  <label for="gestiune">{{ $t('gestiune.gestiune') }}*</label>
                  <select v-model="bonConsum.gestiune" class="form-control" :disabled="isEdit">
                    <option disabled :value="null">Selectează gestiunea</option>
                    <option
                      v-for="gestiune in filteredGestiuni"
                      :key="gestiune.id"
                      :value="gestiune.id"
                    >
                      {{ gestiune.name }}
                    </option>
                  </select>
                </div>
              </div>

              <div class="col-md-2">
                <div class="form-group">
                  <label for="serie">{{ $t('invoice.series') }}*</label>
                  <select v-model="bonConsum.serie" class="form-control" @change="handleSerieChange" :disabled="isEdit">
                    <!-- Placeholder -->
                    <option disabled value="">Selectează seria</option>

                    <option
                      v-for="serie in seriesOptionsWithAdd"
                      :key="serie.id"
                      :value="serie.id"
                    >
                      {{ serie.id === 'add' ? serie.name : `${serie.name} - ${serie.currentNumber}` }}
                    </option>

                    <option
                      v-if="bonConsum.serie && !seriesOptionsWithAdd.some(s => s.id === bonConsum.serie)"
                      :value="bonConsum.serie"
                    >
                      {{ bonConsum.serie }}
                    </option>
                  </select>
                </div>
              </div>

              <div class="col-md-2">
                <div class="form-group">
                  <label for="lot">{{ $t('gestiune.lot') }}</label>
                  <el-input v-model="bonConsum.lot" placeholder="Introdu lotul" :disabled="isEdit" />
                </div>
              </div>

              <div class="col-md-2">
                <div class="form-group">
                  <label>{{$t('gestiune.data')}}*</label>
                  <input type="datetime-local" name="date" v-model="bonConsum.date" :max="today" :disabled="!selectedLocationId" @change="checkValidatedAfter(bonConsum.date)" class="form-control">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card mar-to-15">
        <div class="card-content">
          <div class="col-md-12">
            <p>{{$t('gestiune.addProductInBonConsum')}}</p>
            <hr class="sm">
          </div>

          <el-table :data="tableData" style="width: 100%">
            <el-table-column :label="$t('gestiune.productName')" prop="productName">
              <template slot-scope="scope">
                {{ scope.row.productName }}
              </template>
            </el-table-column>

            <el-table-column :label="$t('gestiune.um')" prop="um">
              <template slot-scope="scope">
                {{ scope.row.um }}
              </template>
            </el-table-column>

            <el-table-column :label="$t('gestiune.cantitateNecesara')" prop="cantitateNecesara">
              <template slot-scope="scope">
                {{ scope.row.cantitateNecesara }}
              </template>
            </el-table-column>

            <el-table-column :label="$t('gestiune.cantitateConsumata')" prop="cantitateConsumata">
              <template slot-scope="scope">
                {{ scope.row.cantitateConsumata }}
              </template>
            </el-table-column>

            <el-table-column :label="$t('general.actions')" width="100">
              <template slot-scope="scope">
                <el-dropdown trigger="click" placement="bottom-end">
                  <!-- Trigger: săgeată jos cu border violet -->
                  <span class="arrow-box">&#9662;</span>

                  <el-dropdown-menu slot="dropdown" class="custom-dropdown-menu">
                    <el-dropdown-item @click.native="editRow(scope.row)">
                      {{$t('general.edit')}}
                    </el-dropdown-item>
                    <el-dropdown-item @click.native="deleteRow(scope.row)">
                      {{$t('general.delete')}}
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </template>
            </el-table-column>

          </el-table>
          <button class="btn add mar-rt-10 mar-bt-5 mar-to-15" :disabled="!selectedLocationId" @click.prevent="openAddProductModal" :title="$t('general.add') + ' ' + $t('settingUsers.single')">
            <img src="/static/img/icons/add.png">
            {{$t('gestiune.addProduct')}}
          </button>
        </div>
      </div>
      <div class="col-md-6 no-padding">
        <div class="card">
          <div class="card-content">
            <div class="modal-header">
              <p>{{ $t('gestiune.stoc.action.bonConsum') }}</p>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label for="gestionar">{{ $t('gestiune.manager') }}</label>
                    <el-input v-model="bonConsum.manager" placeholder="Introdu numele gestionarului" />
                  </div>

                  <div class="form-group">
                    <label for="primitor">{{ $t('gestiune.receiver') }}</label>
                    <el-input v-model="bonConsum.receiver" placeholder="Introdu numele primitorului" />
                  </div>

                  <div class="form-group">
                    <label for="comandaProiect">{{ $t('gestiune.commandProject') }}</label>
                    <el-input v-model="bonConsum.commandProject" placeholder="Adaugă o comandă/proiect" />
                  </div>

                 <div class="form-group">
                    <label for="type">{{ $t('gestiune.type') }}*</label>
                    <el-select
                      v-model="bonConsum.consumptionType"
                      placeholder="Selectează motivul consumului"
                      class="w-full"
                    >
                      <el-option label="Bon de consum pentru producție" value="producție" />
                      <el-option label="Bon de consum pentru casare" value="casare" />
                      <el-option label="Bon de consum pentru testare / training / evenimente" value="testare" />
                      <el-option label="Bon de consum pentru consum propriu" value="consum_propriu" />
                    </el-select>
                  </div>

                  <div class="form-group">
                    <label for="notaInterna">{{ $t('gestiune.internalNote') }}</label>
                    <el-input v-model="bonConsum.internalNote" placeholder="Adaugă o notă internă" type="textarea" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <vmodal name="addProductModal" height="auto" width="600" class="addProductModal">
        <div class="card">
          <div class="card-content">
            <div class="modal-header">
              <p>{{$t('gestiune.addProduct')}}</p>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="stock-info mt-2" style="margin-bottom: 10px; padding: 0px 14px;">
                  <span class="d-block">
                    Stoc: <strong>{{ formatNumber(stockInfo.quantity) }}</strong>
                  </span>

                  <span class="d-block">
                    Valoare: <strong>{{ formatNumber(stockInfo.value) }}</strong>
                  </span>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label>{{$t('gestiune.productName')}}*</label>
                    <v-select
                      v-model="item.productObject"
                      :options="searchResults"
                      label="label"
                      :reduce="option => option.value"
                      placeholder="Caută un produs..."
                      :filterable="false"
                      @search="fetchProducts"
                      @input="handleProductSelect"
                    >
                      <template #no-options>
                        <span v-if="!loading">Niciun produs găsit</span>
                      </template>
                    </v-select>

                    <div v-if="loading" class="v-select-loader"></div>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group">
                    <label>{{$t('gestiune.um')}}*</label>
                    <select v-model="item.um" class="form-control" disabled>
                      <option :value="item.um" disabled>{{item.um}}</option>
                    </select>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group">
                    <label>{{ $t('gestiune.cantitateConsumata') }}*</label>
                    <input
                      type="number"
                      v-model="item.cantitateConsumata"
                      class="form-control"
                      :placeholder="$t('gestiune.cantitateConsumata')"
                      @input="item.cantitateNecesara = item.cantitateConsumata"
                    />
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group">
                    <label>{{ $t('gestiune.cantitateNecesara') }}*</label>
                    <input
                      type="number"
                      disabled
                      v-model="item.cantitateNecesara"
                      class="form-control"
                      :placeholder="$t('gestiune.cantitateNecesara')"
                    />
                  </div>
                </div>

              </div>
            </div>

            <div class="modal-footer">
              <div class="button-group">
                <a class="btn btn-danger btn-icon mar-rt-10 delete" @click="closeModal">
                  {{$t('general.cancel2')}}
                </a>
                <button class="btn btn-icon btn-success mar-rt-10 save" @click="saveProduct">
                  {{$t('general.save')}}
                </button>
              </div>
            </div>
          </div>
        </div>
      </vmodal>

      <ManagementSeriesAdd
        :locations="locations"
        :grouped-locations="groupedLocations"
        :vat-number="selectedLocation ? selectedLocation.inv_fiscal_code : ''"
        @getSeries="getSeries"
      />
    </div>
</template>

<script>
  import PSwitch from 'src/components/UIComponents/Switch.vue'
  import ManagementSeriesAdd from '../../Management/ManagementSeriesAdd.vue'
  import swal from 'sweetalert2'

  function getLocalDateTimeString () {
    const now = new Date()
    const year = now.getFullYear()
    const month = String(now.getMonth() + 1).padStart(2, '0')
    const day = String(now.getDate()).padStart(2, '0')
    const hours = String(now.getHours()).padStart(2, '0')
    const minutes = String(now.getMinutes()).padStart(2, '0')
    return `${year}-${month}-${day}T${hours}:${minutes}`
  }

  export default {
    components: {
      PSwitch,
      ManagementSeriesAdd
    },
    data () {
      return {
        selectedLocationId: '',
        selectedLocation: null,
        locations: [],
        gestiuneOptions: [],
        seriesOptions: [],
        searchResults: [],
        fetchTimer: null,
        currencyOptions: [
          { code: 'RON', name: 'Leu Românesc (RON)' },
          { code: 'EUR', name: 'Euro (EUR)' },
          { code: 'USD', name: 'Dolar American (USD)' }
        ],
        stockInfo: {
          quantity: 0,
          value: 0
        },
        bonConsum: {
          date: getLocalDateTimeString(),
          gestiune: null,
          serie: null,
          currency: 'RON',
          manager: '',
          receiver: '',
          internalNote: '',
          commandProject: '',
          consumptionType: '',
          lot: ''
        },
        loading: false,
        isEdit: !!this.route.params.series && !!this.route.params.number,
        editIndex: null,
        tableData: [],
        item: {
          productObject: null,
          um: '',
          cantitate: null,
          cantitateNecesara: null,
          cantitateConsumata: null
        }
      }
    },
    props: {
      route: {
        type: Object,
        default: () => ({})
      }
    },
    computed: {
      today () {
        const now = new Date()
        now.setSeconds(0, 0)
        return now.toISOString().slice(0, 16)
      },
      seriesOptionsWithAdd () {
        return [
          ...this.seriesOptions,
          { id: 'add', name: '➕ Adaugă serie' }
        ]
      },
      groupedLocations () {
        const groups = {}

        if (!this.locations || !this.locations.length) return []

        this.locations.forEach(location => {
          const vat = location.inv_fiscal_code || 'Fără cod fiscal'
          if (!groups[vat]) {
            groups[vat] = []
          }
          groups[vat].push(location)
        })

        const result = Object.entries(groups).map(([vat, locations]) => ({
          vat,
          locations
        }))

        return result
      },
      filteredGestiuni () {
        if (!this.selectedLocationId) return []
        const result = this.gestiuneOptions.filter(
          (g) => g.externalLocationId === this.selectedLocationId
        )
        return result
      }
    },
    created () {
      this.companyID = this.$session.get('selectedCompany')

      this.fetchGestiuni()
      this.fetchLocation()
    },
    watch: {
      selectedLocationId (id) {
        if (!this.isEdit) {
          this.bonConsum.gestiune = null
          this.bonConsum.serie = null
          this.series = null
          this.documentNumber = null
          this.selectedLocation = null
        }

        for (const group of this.groupedLocations) {
          const loc = group.locations.find(l => l.true_id === id)
          if (loc) {
            this.selectedLocation = loc
            if (!this.isEdit && loc.inv_fiscal_code) {
              this.getSeries(loc.inv_fiscal_code)
            }
            break
          }
        }
      },
      locations (newLocations) {
        if (newLocations && newLocations.length) {
          const s = this.route && this.route.params && this.route.params.series
          const inv = this.route && this.route.params && this.route.params.number
          if (s && inv) {
            this.fetchBonConsum(s, inv)
          }
        }
      }
    },
    methods: {
      validate () {
        this.$validator.validateAll().then(isValid => {
          if (isValid) { this.saveBonConsum() }
        })
      },
      getEmptyItem () {
        return {
          editIndex: null,
          productObject: null,
          um: 'buc',
          cantitate: null,
          cantitateNecesara: null,
          cantitateConsumata: null
        }
      },
      formatNumber (value) {
        if (value === null || value === undefined || value === '') return '0'

        return Number(value).toLocaleString('ro-RO', {
          minimumFractionDigits: 0,
          maximumFractionDigits: 20
        })
      },
      handleSerieChange (event) {
        const val = event.target.value
        if (val === 'add') {
          this.openSeriesModal()
          this.bonConsum.serie = null
        }
      },
      openSeriesModal () {
        this.$modal.show('addSeriesModal')
      },
      async fetchLocation () {
        const dataToSend = {
          company_id: this.companyID,
          token: this.$session.get('token')
        }

        this.apiRequest('/gestiune/locations', 'GET', dataToSend, (response) => {
          if (!response || response.status !== true || !response.data || !response.data.locations) {
            swal({
              title: 'Eroare!',
              text: response.message || 'Eroare la preluarea locațiilor.',
              type: 'error',
              timer: 3000,
              showConfirmButton: false
            })
            return
          }

          this.locations = response.data.locations
        })
      },
      async fetchBonConsum (seriesParam, invoiceNumberParam) {
        const transformDate = (isoString) => {
          const d = new Date(isoString)
          const year = d.getFullYear()
          const month = String(d.getMonth() + 1).padStart(2, '0')
          const day = String(d.getDate()).padStart(2, '0')
          const hours = String(d.getHours()).padStart(2, '0')
          const minutes = String(d.getMinutes()).padStart(2, '0')
          return `${year}-${month}-${day}T${hours}:${minutes}`
        }

        try {
          const response = await fetch(
            `${process.env.API_BASE_URL_GESTIUNE}:4443/getDocument?tip=bon_consum&series=${seriesParam}&number=${invoiceNumberParam}&externalCompanyId=${this.companyID}`
          )

          if (!response.ok) throw new Error('Failed to fetch bon de consum')

          const data = await response.json()

          if (!data || !Array.isArray(data.documents) || !data.documents.length) {
            throw new Error('Bon de consum inexistent')
          }

          const bon = data.documents[0]

          const extra = bon.extraFields || []
          const getField = (key) => {
            const field = extra.find(f => f.key === key)
            return field ? field.value : ''
          }

          const matchedGestiune = this.gestiuneOptions.find(g => g.name === bon.gestiune_from)
          const gestiuneId = matchedGestiune ? matchedGestiune.id : bon.gestiune_from

          this.bonConsum = {
            ...this.bonConsum,
            gestiune: gestiuneId,
            serie: bon.series,
            lot: bon.lot || '',
            date: transformDate(bon.date),
            documentNumber: bon.documentNumber,
            manager: getField('manager'),
            receiver: getField('receiver'),
            internalNote: getField('internalNote'),
            commandProject: getField('commandProject'),
            consumptionType: getField('consumptionType')
          }

          this.tableData = (bon.items || []).map(item => ({
            productName: item.name,
            cantitateNecesara: item.quantity_needed,
            cantitateConsumata: item.quantity_consumed,
            um: item.um,
            posId: item.posId
          }))

          if (bon.externalLocationId && this.locations && this.locations.length) {
            // Căutăm locația potrivită în groupedLocations
            let foundLocation = null
            for (const group of this.groupedLocations) {
              foundLocation = group.locations.find(loc =>
                (bon.externalLocationId && loc.true_id === bon.externalLocationId) ||
                (bon.vatNumber && loc.inv_fiscal_code === bon.vatNumber)
              )
              if (foundLocation) break
            }
            if (foundLocation) {
              this.selectedLocationId = foundLocation.true_id
            }
          }
        } catch (error) {
          console.error('Error fetching bon de consum:', error)
        }
      },
      async checkValidatedAfter (date, products = null) {
        try {
          if (!date) return false

          if (!products) {
            if (!this.tableData || this.tableData.length === 0) {
              products = []
            } else {
              products = this.tableData.map(item => item.posId)
            }
          }

          const queryParams = new URLSearchParams({
            date: new Date(date).toISOString(),
            externalCompanyId: this.companyID,
            externalLocationId: this.selectedLocationId
          })

          const body = products.length > 0 ? { products } : null

          const response = await fetch(
            `${process.env.API_BASE_URL_GESTIUNE}:4443/inventar/validated-after-products?${queryParams.toString()}`,
            {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: body ? JSON.stringify(body) : null
            }
          )

          if (!response.ok) throw new Error(`Request failed: ${response.status}`)

          const data = await response.json()
          console.log('Response from validated-after:', data)

          if (data.exists) {
            await swal({
              icon: 'warning',
              title: 'Atenție!',
              text: 'Există deja un inventar validat după această dată pentru unul sau mai multe produse selectate.'
            })

            return false
          }

          return true
        } catch (err) {
          console.error(err)
          swal({
            icon: 'error',
            title: 'Eroare!',
            text: 'Nu s-a putut verifica inventarul.'
          })
          return false
        }
      },
      async saveProduct () {
        if (!this.item.productObject || !this.item.cantitateNecesara || !this.item.cantitateConsumata) {
          swal({
            title: 'Eroare',
            text: 'Te rugăm să completezi toate câmpurile necesare!',
            type: 'error',
            timer: 2000,
            showConfirmButton: false
          })
          return
        }

        const productId = this.item.productObject.product_id || this.item.productObject.posId

        const isValid = await this.checkValidatedAfter(this.bonConsum.date, [productId])
        if (!isValid) return

        const product = this.item.productObject

        const newItem = {
          ...this.item,
          productName: product && product.productDetails && product.productDetails.name
            ? product.productDetails.name
            : product.label || product.name,
          posId: product && (product.product_id || product.posId)
        }

        console.log('New item added:', newItem)

        if (this.editIndex !== null && this.editIndex !== undefined) {
          this.$set(this.tableData, this.editIndex, newItem)
        } else {
          this.tableData.push(newItem)
        }

        this.resetModal()
        this.$modal.hide('addProductModal')
      },
      editRow (row) {
        const index = this.tableData.indexOf(row)
        if (index === -1) return

        this.editIndex = index


        const productObject = {
          posId: row.posId,
          productDetails: {
            name: row.productName,
            posId: row.posId,
            um: row.um
          },
          label: row.productName
        }

        const productOption = {
          label: row.productName,
          value: productObject
        }

        this.searchResults = [productOption]

        this.item = {
          productObject: productObject, // reținem doar valoarea, cum v-model o face
          um: row.um,
          cantitateNecesara: row.cantitateNecesara,
          cantitateConsumata: row.cantitateConsumata,
          posId: row.posId || null
        }

        this.$modal.show('addProductModal')
      },
      deleteRow (row) {
        const index = this.tableData.indexOf(row)

        if (index !== -1) {
          this.tableData.splice(index, 1)
        }
      },
      async _fetchProducts (searchTerm) {
        this.searchResults = []

        if (!this.selectedLocation || !this.companyID || !this.bonConsum.gestiune || !searchTerm || searchTerm.length < 2) {
          return
        }

        let url = `${process.env.API_BASE_URL_GESTIUNE}:4443/products?externalCompanyId=${this.companyID}`
        url += `&gestiune=${this.bonConsum.gestiune}`
        url += `&externalLocationId=${this.selectedLocation.true_id}`
        url += `&name=${encodeURIComponent(searchTerm)}`

        this.loading = true
        try {
          const response = await fetch(url)
          const data = await response.json()

          if (Array.isArray(data.products)) {
            this.searchResults = data.products.map(item => ({
              label: item.name,
              posId: item._id,
              value: item
            }))
            console.log(this.searchResults)
          } else {
            this.searchResults = []
            console.error('Invalid data format:', data)
          }
        } catch (error) {
          console.error('Error fetching stock:', error)
        } finally {
          this.loading = false
        }
      },
      fetchProducts (searchTerm) {
        // dacă există un timer, îl anulăm
        if (this.fetchTimer) {
          clearTimeout(this.fetchTimer)
        }

        // setăm un nou timer
        this.fetchTimer = setTimeout(() => {
          this._fetchProducts(searchTerm)
        }, 300) // 300ms debounce
      },
      async fetchGestiuni () {
        try {
          const response = await fetch(`${process.env.API_BASE_URL_GESTIUNE}:4443/gestiuni?externalCompanyId=${this.companyID}`)
          if (!response.ok) throw new Error('Failed to fetch gestiuni')

          const data = await response.json()
          console.log('Date primite de la server:', data.gestiuni)
          if (data && data.gestiuni && Array.isArray(data.gestiuni)) {
            this.gestiuneOptions = data.gestiuni.map(gest => ({
              id: gest._id,
              name: `${gest.name} (${gest.cod_gestiune})`,
              externalLocationId: gest.externalLocationId || ''
            }))
          } else {
            swal({
              title: 'Error!',
              text: 'Nu s-a primit un array valid de la server.',
              type: 'error',
              timer: 2000,
              showConfirmButton: false
            })
          }
        } catch (error) {
          swal({
            title: 'Error!',
            text: `Request failed: ${error.message}`,
            type: 'error',
            timer: 2000,
            showConfirmButton: false
          })
          console.error('Error fetching management data:', error)
        }
      },
      async getSeries (vatNumber) {
        try {
          const response = await fetch(`${process.env.API_BASE_URL_GESTIUNE}:4443/getSeries`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              externalCompanyId: this.companyID,
              vatNumber: vatNumber,
              tip: 'bon_consum'
            })
          })

          if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`)
          }

          const data = await response.json()
          console.log('Serii primite:', data.series)

          if (Array.isArray(data.series)) {
            this.seriesOptions = data.series.map(serie => ({
              id: serie._id,
              name: serie.series,
              currentNumber: serie.currentNumber
            }))
          } else {
            console.error('Format invalid pentru series:', data)
          }
        } catch (error) {
          console.error('Error fetching series:', error)
        }
      },
      async saveBonConsum () {
        if (!this.tableData || this.tableData.length === 0) {
          swal({
            title: 'Eroare',
            text: 'Este necesar un produs minim de adăugat.',
            type: 'error',
            timer: 2000,
            showConfirmButton: false
          })
          return
        }

        const selectedSerie = this.seriesOptions.find(
          serie => serie.id === this.bonConsum.serie || serie.name === this.bonConsum.serie
        )
        const serieName = selectedSerie ? selectedSerie.name : this.bonConsum.serie || null

        const gestiuneId = this.bonConsum.gestiune || null

        const bonConsumData = {
          externalCompanyId: this.companyID,
          externalLocationId: this.selectedLocation.true_id,
          vatNumber: this.selectedLocation.inv_fiscal_code,
          series: serieName,
          lot: this.bonConsum.lot || '',
          tip: 'bon_consum',
          gestiune_from: gestiuneId,
          items: this.tableData.map(item => ({
            posId: item.posId,
            name: item.productName,
            quantity: item.cantitateNecesara,
            quantity_needed: item.cantitateNecesara,
            quantity_consumed: item.cantitateConsumata,
            price: item.unitPrice,
            um: item.um
          })),
          currency: this.bonConsum.currency,
          extraFields: Object.entries({
            manager: this.bonConsum.manager,
            receiver: this.bonConsum.receiver,
            commandProject: this.bonConsum.commandProject,
            internalNote: this.bonConsum.internalNote,
            consumptionType: this.bonConsum.consumptionType
          }).map(([key, value]) => ({ key, value }))
        }

        if (this.bonConsum.date) {
          bonConsumData.date = this.bonConsum.date
        }
        if (this.bonConsum.documentNumber) {
          bonConsumData.documentNumber = this.bonConsum.documentNumber
        }

        swal({
          title: 'Salvare în curs...',
          text: 'Se salvează Bonul de Consum. Așteaptă te rog.',
          buttons: false,
          closeOnClickOutside: false,
          closeOnEsc: false,
          type: 'info'
        })

        try {
          const response = await fetch(`${process.env.API_BASE_URL_GESTIUNE}:4443/bon`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(bonConsumData)
          })

          const data = await response.json()

          swal.close()

          if (response.ok) {
            console.log('Bon consum salvat cu succes!', data)

            swal({
              title: 'Succes',
              text: 'Bonul consum a fost salvat cu succes!',
              type: 'success',
              timer: 1500,
              showConfirmButton: false
            })

            this.$bus.$emit('refresh')
            this.$bus.$emit('close-modal')
          } else {
            console.error('Eroare la salvarea bonului consum', data)

            swal({
              title: 'Eroare',
              text: data.details || data.error || 'A apărut o eroare la salvarea bonului consum.',
              type: 'error',
              timer: 1500,
              showConfirmButton: false
            })
          }
        } catch (error) {
          swal.close()
          console.error('Eroare la trimiterea cererii', error)

          swal({
            title: 'Eroare',
            text: 'A apărut o problemă la trimiterea cererii.',
            type: 'error',
            timer: 1500,
            showConfirmButton: false
          })
        }
      },
      async fetchStockForProducts (productIDs, companyID, gestiune, locationID) {
        if (!productIDs || productIDs.length === 0) return []

        const params = new URLSearchParams()
        productIDs.forEach(id => params.append('product_ids', id))

        const url = `${process.env.API_BASE_URL_GESTIUNE}:4443/stock?externalCompanyId=${companyID}` +
                    `&gestiune=${gestiune}` +
                    `&externalLocationId=${locationID}&${params.toString()}`

        swal({
          type: 'info',
          title: 'Loading Stock...',
          text: 'Please wait while we fetch stock data...',
          allowOutsideClick: false,
          allowEscapeKey: false,
          showConfirmButton: false
        })

        try {
          const response = await fetch(url)
          const data = await response.json()

          if (Array.isArray(data.stock)) {
            return data.stock
          } else {
            console.error('Invalid data format:', data)
            return []
          }
        } catch (err) {
          console.error('Error fetching stock:', err)
          return []
        } finally {
          swal.close()
        }
      },
      async handleProductSelect (selectedProduct) {
        const productId =
          (selectedProduct && selectedProduct.posId) ||
          (selectedProduct && selectedProduct.value && selectedProduct.value._id)

        if (!productId) return

        const stockData = await this.fetchStockForProducts(
          [productId],
          this.companyID,
          this.bonConsum.gestiune,
          this.selectedLocation.true_id
        )

        if (!stockData || stockData.length === 0) return

        const stock = stockData[0]

        if (stock && stock.productDetails && stock.productDetails.um) {
          this.item.um = stock.productDetails.um
        }

        this.stockInfo = {
          quantity: stock && stock.quantity ? stock.quantity : 0,
          value: stock && stock.value ? stock.value : 0
        }
      },
      openAddProductModal () {
        this.$modal.show('addProductModal')
      },
      goBack () {
        this.$bus.$emit('refresh')
        this.$bus.$emit('close-modal')
      },
      closeModal () {
        this.resetModal()
        this.$modal.hide('addProductModal')
      },
      resetModal () {
        this.item = this.getEmptyItem()
        this.editIndex = null
        this.stockInfo = {
          quantity: 0,
          value: 0
        }
      }
    }
  }
</script>
<style scoped>
.v-select input[type=search], .v-select input[type=search]:focus,
.v-select.searchable .dropdown-toggle {
    min-height: 46px;
    height: 46px;
}
.v-select .dropdown-toggle {
    height: 46px;
}
.btn-primary {
  padding: 5px 50px;
}
.el-select,
.el-input {
  display: block;
}
.button-group {
    display: flex; /* Folosește flexbox pentru alinierea orizontală */
    justify-content: flex-end; /* Aliniază butoanele la dreapta */
}
.button-group .btn {
    margin-right: 10px; /* Adaugă un spațiu între butoane */
}
.button-group .btn:last-child {
    margin-right: 0; /* Elimină marginea dreaptă pentru ultimul buton */
}
.v-select-wrapper {
  position: relative;
}
.v-select-loader {
  position: absolute;
  right: 25px;
  top: 50%;
  transform: translateY(-50%);
  border: 3px solid #e0e0e0;     /* mai deschis */
  border-top: 3px solid #007bff;  /* mai contrastant */
  border-radius: 50%;
  width: 24px;                    /* mai mare */
  height: 24px;
  animation: spin 0.8s linear infinite;
}
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
.arrow-box {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border: 2px solid #674BD2;
  border-radius: 6px;
  color: #674BD2;
  font-size: 18px;
  cursor: pointer;
  transition: all 0.2s;
}
.stock-info {
  font-size: 13px;
}
.stock-info span strong{
  color: #25396F;
}
.arrow-box:hover {
  background-color: #674BD2;
  color: #fff;
}

.custom-dropdown-menu {
  min-width: 140px;
}

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Management/Stocks/ManagementStocksForm.vue